import Vue from 'vue'
import VueRouter from 'vue-router'
// import home from '../views/home.vue'
// import school from '../views/school.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => window.scrollTo(0,0))
}

const routes = [
  {
    path: '/',
    name: 'Home',
    meta:{
      title:'nCompass为您解答流量数据中的任何问题-智维盈讯'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
    // component: home,
    },
  {
    path:'/school',
    name:'School',
    meta:{
      title:'nCompass大学'
    },
    component(resolve){
      require(['../views/school.vue'],resolve)
    }
    // component: school

  },
  {
    path:'/product',
    name:'Product',
    meta:{
      title:'nCompass数据可视化分析平台-智维盈讯'
    },
    component(resolve){
      require(['../views/product.vue'],resolve)
    }
  },
  {
    path:'/user',
    name:'User',
    meta:{
      title:'用户案例-nCompass'
    },
    component(resolve){
      require(['../views/user.vue'],resolve)
    }
  },
  {
    path:'/solution',
    name:'Solution',
    component(resolve){
      require(['../views/solution.vue'],resolve)
    }
  },
  {
    path:'/partner',
    name:'Partner',
    meta:{
      title:'生态合作-nCompass'
    },
    component(resolve){
      require(['../views/partner.vue'],resolve)
    }
  },
  {
    path:'/support',
    name:'Support',
    meta:{
      title:'服务合作-nCompass'
    },
    component(resolve){
      require(['../views/support.vue'],resolve)
    }
  },
  {
    path:'/about',
    name:'About',
    meta:{
      title:'关于我们-nCompass'
    },
    component(resolve){
      require(['../views/about.vue'],resolve)
    },
  },
    {
      path:'/coverage',
      name:'Coverage',
      meta:{
        title:'媒体报道-nCompass'
      },
      component(resolve){
        require(['../views/coverage.vue'],resolve)
      },
  },
  {
    path:'/detail',
    name:'Detail',
    meta:{
      title:'媒体报道详情-nCompass'
    },
    component(resolve){
      require(['../views/coverageDetail.vue'],resolve)
    },
  },
  {
    path:'/join',
    name:'Join',
    meta:{
      title:'加入nCompass'
    },
    component(resolve){
      require(['../views/join.vue'],resolve)
    }
  },
  // {
  //   path:'/m_home',
  //   name:'m_home',
  //   component(resolve){
  //     require(['../views/app/m_home.vue'],resolve)
  //   }
  // }
  // {
  //   path:'/product',
  //   name:'Product',
  //   component: () => import('../views/product.vue')
  // }
]

const router = new VueRouter({
  mode:'history',
  routes,
})


export default router
